import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sn-placeholder-loading',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./placeholder-loading.component.scss']
})
export class PlaceholderLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
